import { render, staticRenderFns } from "./ThemeToggle.vue?vue&type=template&id=ad740f2a&scoped=true&"
import script from "./ThemeToggle.vue?vue&type=script&lang=js&"
export * from "./ThemeToggle.vue?vue&type=script&lang=js&"
import style0 from "./ThemeToggle.vue?vue&type=style&index=0&id=ad740f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad740f2a",
  null
  
)

export default component.exports